import {
  getBranchesDataSharingWoLoader,
  getClinicBranchesWithClinicIdWoLoader,
  getClinicDetailsWoLoader,
  getClinicFacilitiesWoLoader,
  getClinicLocationsWoLoader,
  getClinicStocksWoLoader,
  getMainClinicDetailsWoLoader,
  getServicesWoLoader,
} from "../redux/reducers/clinicSlice";
import { getClinicVetsWoLoader } from "../redux/reducers/vetSlice";
import { writeMandateSession } from "./mandateSessionStorage";

/**
 * Loads clinic / services / stocks / vets / data-sharing and writes `mandateData` session.
 * @param {(action: unknown) => unknown} dispatch Redux dispatch
 * @param {string | null | undefined} role e.g. localStorage `role` (used for doctor main-clinic follow-up calls)
 */
export async function fetchAndStoreMandateSession(dispatch, role) {
  const [
    clinicRes,
    servicesRes,
    stocksRes,
    vetsRes,
    facilityRes,
    locationRes,
    dataShareRes,
  ] = await Promise.all([
    dispatch(getClinicDetailsWoLoader()),
    dispatch(getServicesWoLoader()),
    dispatch(getClinicStocksWoLoader()),
    dispatch(getClinicVetsWoLoader("?type=all")),
    dispatch(getClinicFacilitiesWoLoader()),
    dispatch(getClinicLocationsWoLoader()),
    role !== "ROLE_RADIOLOGY"
      ? dispatch(getBranchesDataSharingWoLoader())
      : Promise.resolve(null),
  ]);
  const reqObj = {};
  if (clinicRes?.payload) {
    const mainClinicId = Number(clinicRes?.payload?.mainClinicId);
    // if (role === "ROLE_DOCTOR" && Number.isFinite(mainClinicId)) {
    const resolvedClinicId = mainClinicId === 1 ? 2 : mainClinicId;
    if (role !== "ROLE_RADIOLOGY") {
      dispatch(getMainClinicDetailsWoLoader(resolvedClinicId));
      dispatch(
        getClinicBranchesWithClinicIdWoLoader(`?clinicId=${resolvedClinicId}`),
      );
    }
    // }
    reqObj.clinic = clinicRes?.payload ?? {};
  }
  if (dataShareRes?.payload) {
    reqObj.dataSharing = dataShareRes?.payload?.[0] ?? {};
  }
  if (servicesRes?.payload) {
    reqObj.services = servicesRes?.payload?.data ?? [];
  }
  if (stocksRes?.payload) {
    reqObj.stocks = stocksRes?.payload?.data ?? [];
  }
  if (vetsRes?.payload) {
    reqObj.vets = vetsRes?.payload?.data ?? [];
  }
  if (facilityRes?.payload) {
    reqObj.facilities = facilityRes?.payload ?? [];
  }
  if (locationRes?.payload) {
    reqObj.locations = locationRes?.payload ?? [];
  }
  writeMandateSession(reqObj);
}
